import loadScript from '../utils/loadScript';
import forEach from '../utils/forEach';

import Modal from './modal';

function VimeoModal(container, conf) {
    const opts = {
        onOpen: () => null,
        onClose: () => null,
        track: msg => {
            if(__DEVELOPMENT) {
                console.log('Tracking is not enabled.', msg)
            }
        },
        ...conf,
    };

    const modal = new Modal(container);
    const embedContainer = container.querySelector('.embed-container');
    const vimeoId = embedContainer.getAttribute('data-vimeoid');

    let vimeoAPILoaded = typeof window.Vimeo !== 'undefined';
    let player = null;
    let playEnqueued = false;

    function init() {
        loadVimeoApi().then(() => {
            if (player === null) {
                player = new Vimeo.Player(embedContainer, { id: vimeoId });

                Promise.all([
                    player.getVideoWidth(),
                    player.getVideoHeight(),
                ]).then(dimensions => {
                    const [width, height] = dimensions;
                    embedContainer.style.paddingBottom = `${ (height / width) * 100 }%`;
                    if (playEnqueued) {
                        playEnqueued = false;
                        playVideo();
                    }
                });
            }
        });
    }

    function bindEvents() {
        container.addEventListener('click', closeModal);
    }

    function unBindEvents() {
        container.removeEventListener('click', closeModal);
    }

    function loadVimeoApi() {
        return new Promise((resolve, reject) => {
            if(vimeoAPILoaded) {
                return resolve();
            }

            loadScript('https://player.vimeo.com/api/player.js', () => {
                vimeoAPILoaded = true;
                return resolve();
            });
        });
    }

    function openModal () {
        modal.open();
        bindEvents();
        if (player) {
            setTimeout(playVideo, 800);
        } else {
            playEnqueued = true;
        }
        opts.onOpen();
    }

    function closeModal() {
        modal.close();
        unBindEvents();
        if (player) {
            stopVideo();
        }
        opts.onClose();
    }

    function playVideo () {
        // player.setVolume(0);
        player.play().catch(() => null); // swallow the dumb error that video is playing;
        player.getVideoTitle().then((title) => opts.track(title));
    }

    function stopVideo () {
        player.pause()
            .then(() => player.setCurrentTime(0.1))
    }

    init();

    return {
        open: openModal,
        close: closeModal,
    };

};


function handleVideoModalLinkClick(e) {
    e.preventDefault();
    const vimeoId = e.target.dataset.vimeoid;

    if(vimeoId) {
        const modalContainer = document.getElementById(`vimeo-modal-${vimeoId}`);
        const modal = VimeoModal(modalContainer, vimeoId);
        modal.open();
    }
}

export function init() {
    const videoModalLinks = document.querySelectorAll('a[data-vimeoid]');
    if (videoModalLinks.length > 0) {
        forEach(videoModalLinks, (el) => el.addEventListener('click', handleVideoModalLinkClick));
    }
}

export default { init: init }










